export default function EmptyState({ glyph, title, description, compact = false, action }) {
  return (
    <div className={`mx-auto flex max-w-[535px] flex-col items-center justify-center text-center ${compact ? 'py-8' : 'min-h-[60vh] py-16'}`}>
      <div className="relative mb-5 flex size-24 items-center justify-center rounded-full bg-surfaceMuted text-faint">{glyph}</div>
      <p className="font-title text-base font-medium text-ink">{title}</p>
      {description && <p className="mt-2 font-title text-sm leading-5 text-[#757575]">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
